module.exports = __webpack_public_path__ + "img/bg_learninglive_03.a685acab.jpg";